/**
 * Should not be called directly.
 * @see {@link loadingIndicator}
 *
 * @param {NodeList|HTMLElement} forms
 * @param {object} [options]
 * @param {string} [options.indicatorClass]
 * @param {string} [options.loadingClass]
 * @param {string} [options.exclude]
 * @private
 */
export function initIndicator(
    forms,
    { indicatorClass = 'has-loading-indicator', loadingClass = 'is-loading', exclude = '' } = {},
) {
    const addIndicator = (form) => {
        let formSubmitSelector = 'button[type="submit"]:not([target="_blank"])',
            formSubmit;

        const submitters = new WeakMap(),
            indicateLoading = () => {
                if (formSubmit.length === 0) {
                    return;
                }

                let submitter;

                if (submitters.has(form)) {
                    submitter = submitters.get(form);
                } else {
                    submitter = formSubmit[formSubmit.length - 1];
                }

                if (submitter.matches('input')) {
                    // not supported
                    return;
                } else if (submitter.classList.contains(indicatorClass) === false) {
                    submitter.classList.add(indicatorClass);
                }

                submitter.classList.add(loadingClass);
            },
            indicateLoadingDone = () => {
                formSubmit?.forEach((submitter) => {
                    submitter.classList.remove(loadingClass);
                });
            };

        if (exclude) {
            formSubmitSelector += `:not(${exclude})`;
        }

        formSubmit = form.querySelectorAll(formSubmitSelector);

        formSubmit.forEach((submit) => {
            if (submit.hasAttribute('aria-live') === false) {
                submit.setAttribute('aria-live', 'assertive');
            }

            submit.addEventListener(
                'click',
                (event) => {
                    submitters.set(form, event.currentTarget);
                },
                { passive: true },
            );
        });

        form.addEventListener('submit', indicateLoading, { passive: true });
        form.addEventListener('wpcf7beforesubmit', indicateLoading, { passive: true });
        form.addEventListener('wpcf7submit', indicateLoadingDone, { passive: true });
    };

    if (forms instanceof NodeList) {
        forms.forEach((form) => {
            addIndicator(form);
        });
    } else {
        addIndicator(forms);
    }
}
